import { render, staticRenderFns } from "./NewAttendancePage.vue?vue&type=template&id=c9a6a4a6&scoped=true"
import script from "./NewAttendancePage.vue?vue&type=script&lang=js"
export * from "./NewAttendancePage.vue?vue&type=script&lang=js"
import style0 from "./NewAttendancePage.vue?vue&type=style&index=0&id=c9a6a4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a6a4a6",
  null
  
)

export default component.exports